export default __webpack_public_path__ + "static/david-eb2917814413a7f78b8be8871f4417e2.png";